import apiClient from "./Api";

//=============================================================================
// LAYERS
//=============================================================================
/**
 * Obtiene todas las capas de un grupo de capas.
 * @param {string} layerGroupUuid
 */
export const getLayersByLayerGroup = async (layerGroupUuid) => {
  // Endpoint swagger: GET /gis/layers/by_layers_group/{layer_group_uuid}
  const response = await apiClient.get(
    `/gis/layers/by_layers_group/${layerGroupUuid}`
  );
  return response.data;
};

/**
 * Crea una nueva capa.
 * @param {Object} layerData - Objeto conforme a LayerCreate
 */
export const createLayer = async (layerData) => {
  // Endpoint swagger: POST /gis/layers
  const response = await apiClient.post("/gis/layers", layerData);
  return response.data;
};

/**
 * Relaciona una capa con un grupo de capas.
 * @param {string} layerUuid
 * @param {string} layerGroupUuid
 */
export const linkLayerToGroup = async (layerUuid, layerGroupUuid) => {
  // OJO: el path parameter se llama "layer_groupo_uuid" en la especificación
  // Podría ser un posible typo. Usamos layerGroupUuid para mantener consistencia.
  const response = await apiClient.post(
    `/gis/layers/link_to_layer_group/${layerUuid}/${layerGroupUuid}`
  );
  return response.data;
};

/**
 * Obtiene una capa por UUID.
 * @param {string} layerUuid
 */
export const getLayerByUuid = async (layerUuid) => {
  // Endpoint swagger: GET /gis/layers/{layer_uuid}
  const response = await apiClient.get(`/gis/layers/${layerUuid}`);
  return response.data;
};

/**
 * Actualiza una capa por UUID.
 * @param {string} layerUuid
 * @param {Object} layerData - Objeto conforme a LayerCreate
 */
export const updateLayer = async (layerUuid, layerData) => {
  // Endpoint swagger: PUT /gis/layers/{layer_uuid}
  const response = await apiClient.put(`/gis/layers/${layerUuid}`, layerData);
  return response.data;
};

/**
 * Elimina una capa por UUID.
 * @param {string} layerUuid
 */
export const deleteLayer = async (layerUuid) => {
  // Endpoint swagger: DELETE /gis/layers/{layer_uuid}
  const response = await apiClient.delete(`/gis/layers/${layerUuid}`);
  return response.data;
};

/**
 * Relaciona una capa con un estilo.
 * @param {string} layerUuid
 * @param {number} styleId
 */
export const linkLayerToStyle = async (layerUuid, styleId) => {
  // Endpoint swagger: POST /gis/layers/link_style/{layer_uuid}/{style_id}
  const response = await apiClient.post(
    `/gis/layers/link_style/${layerUuid}/${styleId}`
  );
  return response.data;
};

/**
 * Obtiene el GeoJSON de una capa por UUID.
 * @param {string} layerUuid
 */
export const getLayerGeojson = async (layerUuid) => {
  // Endpoint backend: GET /gis/layers/geojson/{layer_uuid}
  const response = await apiClient.get(`/gis/layers/geojson/${layerUuid}`);
  return response.data;
};
